import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom';
import DashboardLayout from '../layout/DashboardLayout';
import Dashboard from '../pages/Dashboard';
import Singlepartypage from '../pages/singlepartypage';
import Addparty from '../pages/addparty';
import Addnewparty from '../pages/addnewparty';
import Stocks from '../pages/stocks';
import Addstock from '../pages/addstock';
import Partylist from '../pages/partylist';
import Settings from '../pages/Settings';
import History from '../pages/history';
import Login from '../pages/Login';
import Register from '../pages/Register';
import ManageUsers from '../pages/ManageUsers';
import Logout from '../pages/Logout';
import BalanceSheet from '../pages/BalanceSheet';
import UserHistory from '../pages/userhistory';


const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const token = localStorage.getItem('token');
    if (!token) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

interface Props { }

function AllRoutes(props: Props) {
    const { } = props

    return (
        <>
            <Routes>
                {/* Public Routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />

                {/* Protected Routes */}
                <Route element={
                    <ProtectedRoute>
                        <DashboardLayout />
                    </ProtectedRoute>
                }>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="party/:id" element={<Singlepartypage />} />
                    <Route path="/add-party" element={<Addparty />} />
                    <Route path="/addnewparty" element={<Addnewparty />} />
                    <Route path="/Stock" element={<Stocks />} />
                    <Route path="/add-stock" element={<Addstock />} />
                    <Route path="/parties-list" element={<Partylist />} />
                    <Route path='/BalanceSheet' element={<BalanceSheet />} />
                    <Route path='/history' element={<History />} >
                        <Route path="/history/stock" element={<h1>help</h1>} />

                    </Route>
                    <Route path="/users" element={<ManageUsers />} />
                    <Route path="/usershistory" element={<UserHistory />} />
                    <Route path="/setting" element={<Settings />} />
                    <Route path="/help" element={<h1>help</h1>} />

                </Route>
                <Route path="/logout" element={<Logout />} />
            </Routes>
        </>
    )
}

export default AllRoutes
